<template>
    <div class="flex-col">
        <vnavbar title="耗材清点" class="backbar" left-text="返回" left-arrow @click-left="back" />
        <div class="header">
            <div class="patient">
                <div class="name">{{surgeryInfo.patient_name}}</div>
                <div class="bed">{{surgeryInfo.sex||'--'}}/{{surgeryInfo.age||'--'}}/{{surgeryInfo.bed_no||'--'}}</div>
            </div>
            <div>
            <div class="more"><div class="moredevice">{{surgeryInfo.surgeries}}</div><div @click="isShowMore=!isShowMore">查看更多<span><i :class="isShowMore?'el-icon-arrow-up':'el-icon-arrow-down'"></i></span></div></div>
            <div v-if="isShowMore" class="surgery">
                <div>台次:{{surgeryInfo.scheduled_sequence}}</div>
                <div>手术间:{{surgeryInfo.dic_operating_room}}</div>
                <div>科室:{{surgeryInfo.dic_section}}</div>
                <div>术前诊断:{{surgeryInfo.plan_diseases}}</div>
                <div>手术医生:{{surgeryInfo.surgeon}}</div>
                <div class="time">手术计划开始时间:{{surgeryInfo.plan_time && this.$moment(surgeryInfo.plan_time).format(`YYYY-MM-DD HH:mm:ss`)}}</div>
            </div>
            </div>
        </div>
        <vtabs class="tabcard" type="card" :style="{'margin-top':'2px','height':`${ this.screenHeight - 180}px`}" v-model="activeIndex">
            <vtab v-for="(tab, index) in countStage" :key="index" :title="tab.stage_name" :name="index">
                <i v-if="activeIndex>0 && tab.calculate_relation" @click="syncPrevData(activeIndex)" class="el-icon-refresh-right" style="float: right;font-size: 22px;margin-right: 20px;padding: 10px 0px;color: #04A891;" title="同步上一步清点数据">同步</i>
                <div :style="{'height':`${ screenHeight - 210}px`}" style="overflow-y: scroll;">
                    <vcell v-for="(item, i) in stagesData" :key="i">
                        <template slot="title">
                            <div style="text-align: left;padding-left: 20px;">{{item.supply_alias}}</div>
                        </template>
                        <vstepper slot="right-icon" v-model="item.amount[index]" min="0" button-size="24px" input-width="38px"
                            class="absolute right14" />
                    </vcell>
                </div>
            </vtab>
        </vtabs>
        <div class="bottom">
            <vbutton v-show="isAdd" class="btnTrans" type="primary" @click="showaddSupply">新增清点项</vbutton>
            <vbutton class="btnTrans" type="primary" @click="saveCountStage">保存</vbutton>
        </div>

        <van-dialog v-model="addSupply.isShow" :title="addSupply.nodeName" show-cancel-button @cancel="addSupply.isShow = false" @confirm="confirmAddSupply">
            <vcellgroup v-if="allSupplies && allSupplies.length>0">
                <vfield v-model="addSupply.amount" type="number" label="数量" />
                <vsearch placeholder="请输入搜索关键词" v-model="addSupply.searchValue" :show-action="showAction" @search="onSearch" @focus="onFocus"></vsearch>
                <vCheckboxGroup v-model="addSupply.result" style="height: 200px; overflow-y: auto;" ref="checkboxGroup">
                    <vCheckbox style="padding-left: 10px;font-size: large;height: 40px;border: 1px solid #dcdfe6;" v-for="(item, index) in allSupplies" :key="index" :name="item.value">
                        <span style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 250px;display: block; ">{{item.label}}</span>
                    </vCheckbox>
                </vCheckboxGroup>
            </vcellgroup>
        </van-dialog>
    </div>
</template>

<script>
import { CellGroup as vcellgroup, Cell as vcell, PullRefresh as vpullrefresh, Stepper as vstepper, Field as vfield, Tab as vtab, Tabs as vtabs, NavBar as vnavbar, Empty, Button as vbutton, Dialog, Tabbar as vtabbar, Search as vsearch, TabbarItem as vtabbaritem, Icon as vicon, Tag as vtag, CheckboxGroup as vCheckboxGroup, Checkbox as vCheckbox } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
export default {
    name: `CountSupply`,
    components: { vcellgroup, vpullrefresh, vcell, vstepper, vfield, vtab, vtabs, vnavbar, Empty, vtabbar, vtabbaritem, vbutton, [Dialog.Component.name]: Dialog.Component, vicon, vtag, vCheckboxGroup, vCheckbox, vsearch },
    data() {
        let sessionSurgeryObj = sessionStorage.getItem(`surgeryInfo`)
        let sessionSurgeryInfo = sessionSurgeryObj && JSON.parse(sessionSurgeryObj) || null
        let sessionCountStageObj = sessionStorage.getItem(`countStage`)
        let sessionCountStage = sessionCountStageObj && JSON.parse(sessionCountStageObj) || null

        let countStages = this.$route.params.countStage || sessionCountStage
        let sessionPrevPath = sessionStorage.getItem(`prevPath`)
        return {
            surgeryId: this.$route.query.surgeryId && parseInt(this.$route.query.surgeryId) || 0,
            surgeryInfo: this.$route.params.surgeryInfo || sessionSurgeryInfo,
            prevPath: this.$route.params.prevPath || sessionPrevPath,
            countStage: countStages || [],
            isShowMore: false,
            showAction: false,
            loading: false,
            finished: true,
            refreshing: false,
            activeIndex: 0,
            allowinit: true,
            stagesData: [],
            addSupply: {
                isShow: false,
                nodeName: ``,
                amount: 0,
                result: []
            },
            allSupplies: [],
            allSuppliesbak: []
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `sysuser/workers`, `screenHeight`, `operation_ward_auth`, `active_hospital_ward`, `active_ward`]),
        activeStage() {
            return this.countStage && this.countStage[this.activeIndex]
        },
        isAdd() {
            let item = this.countStage && this.countStage[this.activeIndex]
            return item && !item.allow_edit
        }
    },
    created() {
        console.log(`countStage`, this.countStage)
        this.loadCountings()
        this.loadAllSupplies()
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
        })
    },
    mounted() { },
    beforeRouteLeave(to, from, next) {
        sessionStorage.setItem(`surgeryId`, this.surgeryId)
        sessionStorage.setItem(`surgeryInfo`, JSON.stringify(this.surgeryInfo))
        sessionStorage.setItem(`countStage`, JSON.stringify(this.countStage))
        sessionStorage.setItem(`prevPath`, this.prevPath)
        next()
    },
    methods: {
        showaddSupply() {
            this.addSupply.isShow = true
            let item = this.countStage && this.countStage[this.activeIndex]
            this.addSupply.nodeName = item && item.stage_name || `添加`
        },
        onSearch() {
            let that = this
            if (that.addSupply.searchValue) {
                that.allSupplies = _.filter(that.allSuppliesbak, d => {
                    return _.includes(d.label, that.addSupply.searchValue) || _.includes(d.jianpin, that.addSupply.searchValue) || _.includes(d.code, that.addSupply.searchValue) || _.includes(that.addSupply.result, d.value)
                })
                console.log(that.allSupplies)
            } else {
                that.allSupplies = that.allSuppliesbak
            }
        },
        onFocus() {
            this.showAction = true
        },
        onCancel() {
            this.showAction = false
        },
        confirmAddSupply() {
            let that = this
            let selectSupplies = _.filter(that.allSuppliesbak, d => { return _.includes(that.addSupply.result, d.value) })
            let count = that.stagesData.length || 0
            let req = this.myaxios.post(`/api/Nursing/CountingSupply/SaveData`, _.map(selectSupplies, (item, index) => {
                return {
                    'dic_supply_id': item.value,
                    'supply_alias': item.alias,
                    'amount': that.addSupply.amount,
                    'display_order': count + index + 1,
                    'biz_count_stage_id': that.countStage && that.countStage[that.activeIndex].id
                }
            }))
            req.then(() => {
                this.loadCountings()
                this.addSupply = {
                    isShow: false
                }
            })
        },
        saveCountStage() {
            let that = this
            let req = this.myaxios.post(`/api/Nursing/CountingSupply/SaveData`, _.map(that.stagesData, (item, index) => {
                return {
                    'dic_supply_id': item.supply_id,
                    'supply_alias': item.supply_alias,
                    'amount': item.amount[that.activeIndex],
                    'display_order': index + 1,
                    'biz_count_stage_id': that.countStage && that.countStage[that.activeIndex].id
                }
            }))
            req.then(() => {
                this.loadCountings()
                this.addSupply = {
                    isShow: false
                }
            })
        },
        back() {
            this.$router.push({ name: `CountingList`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, prevPath: this.prevPath } }).catch(err => err)
        },
        loadCountings() {
            if (!this.countStage) { return }
            let req = this.myaxios.post(`api/Nursing/CountingSupply/GetStagesData`, _.map(this.countStage, d => d.id))
            req.then(data => {
                if (data.length == 0 && this.allowinit) {
                    this.initCoutings()
                } else {
                    this.stagesData = data
                    console.log(data)
                }
            })
        },
        syncPrevData(activeStageIndex) {
            let that = this
            if (activeStageIndex != 0) {
                if (that.activeStage.calculate_relation) {
                    let stageIndexArr = []
                    _.forEach(that.activeStage.calculate_relation.split(`,`), i => {
                        let eventStage = that.countStage.find(o => o.dic_event_id == parseInt(i))
                        if (eventStage) {
                            stageIndexArr.push(eventStage.display_order)
                        }
                    })
                    //
                    _.forEach(that.stagesData, item => {
                        let itemSum = 0
                        if (stageIndexArr.length > 0) {
                            _.forEach(stageIndexArr, index => {
                                itemSum += item.amount[index - 1]
                            })
                        }
                        item.amount.splice(activeStageIndex, 1, itemSum)
                    })
                }
            }
        },
        initCoutings() {
            let req = this.myaxios.get(`/api/AcisSystem/SuppliesCountingOperatingWardConfig/Get`)
            req.then(data => {
                let preloaditems = _.filter(data, d => `ow_${d.dic_operating_ward_id}` == this.active_ward.value)
                if (preloaditems.length > 0) {
                    let req = this.myaxios.post(`/api/Nursing/CountingSupply/SaveData`, _.map(preloaditems, (sp, index) => {
                        return {
                            'dic_supply_id': sp.dic_supplies_id,
                            'supply_alias': sp.supplies_model.alias,
                            'amount': 0,
                            'display_order': index + 1,
                            'biz_count_stage_id': this.countStage[0].value
                        }
                    }))
                    req.then(() => {
                        this.loadCountings()
                    })
                } else {
                    this.allowinit = false
                }
            })
        },
        loadAllSupplies() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/Supplies/Search`)
                req.then(data => {
                    console.log(data)
                    that.allSupplies = data
                    that.allSuppliesbak = _.cloneDeep(that.allSupplies)
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        onLoad() { },
        onRefresh() {
            let that = this
            that.refreshing = false
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            if (newUrl.path == `/t_countsupplycreate`) {
                this.surgeryId = this.$route.query.surgeryId
                this.surgeryInfo = this.$route.params.surgeryInfo
                this.countStage = this.$route.params.countStage
                this.loadCountings()
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.backbar{
    background-color: #04A891;
    border:unset !important;
    /deep/ .van-icon{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__text{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__title{
        color:#ffffff !important;
    }
}
.van-hairline--bottom::after{
    border-bottom-width:0px !important;
}
.header {
    color:#ffffff !important;
    background: #04A891 !important;
    font-size: 14px;
    text-align: left;
    .patient {
        line-height: 23px;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        height: 46px;
        .name{
            padding:0 20px;
            font-size: 17px;
        }
    }
    .surgery {
        border-top: 1px dashed #ffffff;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-wrap: wrap;
        div {
            width: 50%;
            height:30px;
            line-height:30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            padding: 0 16px;
        }
        .time{
            flex-basis:100% !important;
        }
    }
    .more{
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        justify-content: space-between;
        margin: 0 16px;
        padding-bottom: 10px;
        .moredevice{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            max-width: 80%;
        }
        }
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width:100%;
    .btnTrans {
        flex:1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 30px;
        color: #ffffff;
    }
}
.scrollContent{
    overflow-y: auto;
    overflow-x: hidden;
}
.content{
    display:flex;
    font-size:20px;
    .panel{
        position: relative;
        width: 100%;
        padding: 0 16px;
        text-align: left;
        .monthday{
            position: absolute;
            left:-40px;
            top:0px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .date{
            position: absolute;
            left:-40px;
            top:8px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .step{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: start;
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
        }
        .steprowone{
            flex-basis: 70%;
            font-weight: 500;
            font-size: 20px;
            color: var(--primary-color, #009688);
            line-height: 36px;
            height: 36px;
            text-align: left;
            font-style: normal;
            overflow-wrap: break-word;
            white-space: nowrap;
            margin-top: 1px;
        }
        .phone{
            background-color: #E0F2EE;
            border-radius: 50%;
            height: 24px;
            width: 24px;
            line-height: 24px;
            text-align: center;
        }
        .steprowtwo{
            flex-basis: 100%;
            margin-top: 5px;
        }
        .remark{
            flex-basis: 90%;
            padding: 5px 10px 10px 0px;
            background-color: rgba(245, 245, 245, 1);
            border-radius: 2px;
        }
    }
}
.tabcard /deep/ .van-tab{
    color: #04A891;
    border-right: 1px solid #04A891;
}
.tabcard /deep/ .van-tab--active{
    color: #fff;
    background-color: #04A891;
}
.tabcard /deep/ .van-tabs__nav--card{
    border: 1px solid #04A891;;
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/CountSupply.vue